import {
  Button,
  ButtonSize,
  IconButton,
  IconButtonVariant
} from "shared/components";
import {
  ArrowLeft02Icon,
  PlusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

export const ConditionHeader = ({
  editMode,
  onBack,
  onAdd
}: {
  editMode: boolean;
  onBack: () => void;
  onAdd: () => void;
}) => {
  return (
    <header
      className={cx(
        "h-[72px] border-b bg-white border-alpha-100 px-6 flex items-center shrink-0",
        editMode ? "gap-4" : "justify-between"
      )}
    >
      {editMode ? (
        <>
          <IconButton
            HugeIcon={ArrowLeft02Icon}
            variant={IconButtonVariant.TEXT_BASE}
            onClick={onBack}
            aria-label="Back to conditions list"
          />
          <h1 className="text-xl text-content-1000 font-bold">
            Edit condition
          </h1>
        </>
      ) : (
        <>
          <h1 className="text-xl text-content-1000 font-bold">
            Active conditions
          </h1>
          <Button size={ButtonSize.SM} HugeIcon={PlusSignIcon} onClick={onAdd}>
            Add condition
          </Button>
        </>
      )}
    </header>
  );
};
